import { createApp } from 'vue'
import App from './App.vue'
import "bootstrap/dist/css/bootstrap.min.css"
import 'vue-select/dist/vue-select.css';
import "bootstrap"
import "axios"
import Vue3Signature from "vue3-signature"
import printJS from 'print-js';
import apm from './apm'
import { library } from '@fortawesome/fontawesome-svg-core'
import VueMultiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import vSelect from 'vue-select';
import { createPinia } from 'pinia'
import { vuetify } from './plugins/vuetify';
import {
    faTrash,
    faRotate,
    faRectangleXmark,
    faArrowRightLong,
    faMapLocationDot,
    faDatabase,
    faFile,
    faUser,
    faUserSecret,
    faMagnifyingGlass,
    faHeadset,
    faClock,
    faFileCircleExclamation,
    faFilter,
    faArrowLeft,
    faBuilding,
    faSquare,
    faUserCheck,
    faLocationDot,
    faCircleCheck,
    faCircle,
    faCaretDown,
    faCaretUp,
    faPaperclip,
    faCogs,
    faCirclePlus,
    faCircleMinus,
    faCircleXmark,
    faEye,
    faEyeSlash,
    faArrowRightFromBracket,
    faCloudArrowUp,
    faUserPen,
    faFileArrowDown,
    faSquarePlus,
    faSquareCheck,
    faFloppyDisk,
    faEraser,
    faRotateLeft,
    faCircleExclamation,
    faFileLines,
    faBookmark,
    faX,
    faPrint,
    faDownload,
    faEdit,
    faAngleDown,
    faAngleUp,
    faBell,
    faFileCirclePlus,
    faFileCircleQuestion,
    faPencilAlt,
    faCommentDots,
    faEnvelope,
    faPhone,
    faFileCircleCheck,
    faCalendar,
    faCalendarDays,
    faWarning,
    faInfoCircle,
    faCheck, faArrowRight, faList
} from '@fortawesome/free-solid-svg-icons'

import router from './router'
import VueSweetalert2 from 'vue-sweetalert2';
import roleMixin from './mixins/roleMixin';


/* add icons to the library */
library.add(faUserPen, faTrash, faEye, faEyeSlash, faCircleXmark, faCirclePlus, faCircleMinus, faRotate, faRectangleXmark,
    faArrowRightLong, faMapLocationDot, faDatabase, faFile, faUser, faUserSecret, faMagnifyingGlass, faHeadset,
    faClock, faFileCircleExclamation, faFilter, faArrowLeft, faBuilding, faSquare, faUserCheck, faLocationDot, faWarning,
    faCircleCheck, faCircle, faCaretDown, faCaretUp, faPaperclip, faCogs, faArrowRightFromBracket, faCloudArrowUp,
    faFileArrowDown, faSquarePlus, faSquareCheck, faFloppyDisk, faEraser, faRotateLeft, faCircleExclamation, faCalendar, faCirclePlus, faCalendarDays, faFileCirclePlus, faFileCircleQuestion,
    faFileLines, faBookmark, faX, faPrint, faDownload, faEdit, faAngleDown, faAngleUp, faBell, faPencilAlt, faCommentDots, faEnvelope, faPhone, faFileCircleCheck, faInfoCircle, faCheck, faArrowRight, faList)

const app = createApp(App).use(router);
const pinia = createPinia()
app.component('font-awesome-icon', FontAwesomeIcon)
app.config.productionTip = false
app.use(VueSweetalert2)
app.use(Vue3Signature)
app.use(apm)
app.use(vuetify)
app.use(pinia)
app.config.globalProperties.$printJS = printJS; // Make printJS accessible globally

app.component('v-select', vSelect)
app.component('VueMultiselect', VueMultiselect);
app.mixin(roleMixin);
app.mount('#app')
